<template>
  <div class="fixed-nav">
    <v-app-bar color="blue" height="fit-content">
      <v-container fluid>
        <v-row>
          <v-col cols="3">
            <h4 style="cursor: pointer" @click="goToHome" class="logo">
              hot spot <span>+</span>
            </h4>
          </v-col>
          <v-col cols="6">
            <ul
              class="links d-flex justify-space-between"
              style="list-style: none; cursor: pointer"
            >
              <li v-for="categ in categorys" :key="categ.title">
                <router-link
                  style="
                    list-style: none;
                    text-decoration: none;
                    color: white;
                    font-size: 15px;
                    font-weight: 700;
                  "
                  :to="{ name: 'products', params: { cat: categ.title } }"
                >
                  {{ categ.title }}
                </router-link>
              </li>
            </ul>
          </v-col>
          <v-col
            cols="3"
            class="d-flex justify-end align-center"
            style="gap: 15px"
          >
            <v-badge
              class="mr-4"
              location="right top"
              color="red"
              offsetX="-1"
              :content="wishlistLength"
            >
              <div
                class="wishlist d-flex flex-column align-center"
                :style="{
                  cursor: 'pointer',
                  pointerEvents: $route.name === 'cartPage' ? 'none' : 'unset',
                }"
                @click="openWishlist()"
              >
                <svg
                  viewBox="0 0 512 512"
                  class="icon icon-wishlist"
                  style="width: 28px; height: 28px; fill: black"
                >
                  <g>
                    <g>
                      <path
                        d="M474.644,74.27C449.391,45.616,414.358,29.836,376,29.836c-53.948,0-88.103,32.22-107.255,59.25
                            c-4.969,7.014-9.196,14.047-12.745,20.665c-3.549-6.618-7.775-13.651-12.745-20.665c-19.152-27.03-53.307-59.25-107.255-59.25
                            c-38.358,0-73.391,15.781-98.645,44.435C13.267,101.605,0,138.213,0,177.351c0,42.603,16.633,82.228,52.345,124.7
                            c31.917,37.96,77.834,77.088,131.005,122.397c19.813,16.884,40.302,34.344,62.115,53.429l0.655,0.574
                            c2.828,2.476,6.354,3.713,9.88,3.713s7.052-1.238,9.88-3.713l0.655-0.574c21.813-19.085,42.302-36.544,62.118-53.431
                            c53.168-45.306,99.085-84.434,131.002-122.395C495.367,259.578,512,219.954,512,177.351
                            C512,138.213,498.733,101.605,474.644,74.27z M309.193,401.614c-17.08,14.554-34.658,29.533-53.193,45.646
                            c-18.534-16.111-36.113-31.091-53.196-45.648C98.745,312.939,30,254.358,30,177.351c0-31.83,10.605-61.394,29.862-83.245
                            C79.34,72.007,106.379,59.836,136,59.836c41.129,0,67.716,25.338,82.776,46.594c13.509,19.064,20.558,38.282,22.962,45.659
                            c2.011,6.175,7.768,10.354,14.262,10.354c6.494,0,12.251-4.179,14.262-10.354c2.404-7.377,9.453-26.595,22.962-45.66
                            c15.06-21.255,41.647-46.593,82.776-46.593c29.621,0,56.66,12.171,76.137,34.27C471.395,115.957,482,145.521,482,177.351
                            C482,254.358,413.255,312.939,309.193,401.614z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
            </v-badge>

            <div
              class="wishlist d-flex flex-column align-center"
              :style="{
                cursor: 'pointer',
                pointerEvents: $route.name === 'cartPage' ? 'none' : 'unset',
              }"
              @click="openCart"
            >
              <v-badge
                location="right top"
                :content="cardItem.length"
                color="red"
                offsetX="-7"
                style="margin-right: 10px"
              >
                <svg
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                  style="width: 28px; height: 28px"
                >
                  <path
                    class="path1"
                    d="M409.6 1024c-56.464 0-102.4-45.936-102.4-102.4s45.936-102.4 102.4-102.4S512 865.136 512 921.6 466.064 1024 409.6 1024zm0-153.6c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2 51.2-22.968 51.2-51.2-22.968-51.2-51.2-51.2z"
                  ></path>
                  <path
                    class="path2"
                    d="M768 1024c-56.464 0-102.4-45.936-102.4-102.4S711.536 819.2 768 819.2s102.4 45.936 102.4 102.4S824.464 1024 768 1024zm0-153.6c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2 51.2-22.968 51.2-51.2-22.968-51.2-51.2-51.2z"
                  ></path>
                  <path
                    class="path3"
                    d="M898.021 228.688C885.162 213.507 865.763 204.8 844.8 204.8H217.954l-5.085-30.506C206.149 133.979 168.871 102.4 128 102.4H76.8c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6H128c15.722 0 31.781 13.603 34.366 29.112l85.566 513.395C254.65 736.421 291.929 768 332.799 768h512c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-512c-15.722 0-31.781-13.603-34.366-29.11l-12.63-75.784 510.206-44.366c39.69-3.451 75.907-36.938 82.458-76.234l34.366-206.194c3.448-20.677-1.952-41.243-14.813-56.424zm-35.69 48.006l-34.366 206.194c-2.699 16.186-20.043 32.221-36.39 33.645l-514.214 44.714-50.874-305.246h618.314c5.968 0 10.995 2.054 14.155 5.782 3.157 3.73 4.357 9.024 3.376 14.912z"
                  ></path>
                </svg>
              </v-badge>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<style scoped lang="css">
.logo {
  font-size: 20px;
  font-weight: 800;
  background: linear-gradient(65deg, #3d5f7c, #5c825c, #ab3e3e);
  background-clip: text;
  color: transparent;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 5px;
}
.fixed-nav ul li {
  font-size: 15px;
  text-transform: capitalize;
  font-weight: 700;
}
</style>
<script setup>
import { inject, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { cards } from "@/store/card";
const route = useRouter();
const Emitter = inject("Emitter");
const cardIdata = cards();
const { cardItem } = storeToRefs(cardIdata);
const wishlistLength = ref(0);
const openWishlist = () => {
  Emitter.emit("openWishlist");
};
const openCart = () => {
  Emitter.emit("openCart");
};
const categorys = ref([
  {
    title: "Furniture",
    route: "all product",
  },
  {
    title: "groceries",
    route: "hossam",
  },
  {
    title: "WomenClothing",
    route: "ammar",
  },
  {
    title: "Electronics",
    route: "hamed",
  },
  {
    title: "smartphones",
    route: "kasme",
  },
]);
const goToHome = () => {
  route.push({ name: "home" }).then(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
};
const getLength = () => {
  let productsData = 0;
  let phoneData = 0;
  let freshvData = 0;
  let womanData = 0;
  let electronicsData = 0;
  if (localStorage.getItem("productsData")) {
    productsData = JSON.parse(localStorage.getItem("productsData"));
    productsData = productsData.filter((e) => e.wishlist).length;
  }
  if (localStorage.getItem("phoneData")) {
    phoneData = JSON.parse(localStorage.getItem("phoneData"));
    phoneData = phoneData.filter((e) => e.wishlist).length;
  }
  if (localStorage.getItem("freshvData")) {
    freshvData = JSON.parse(localStorage.getItem("freshvData"));
    freshvData = freshvData.filter((e) => e.wishlist).length;
  }
  if (localStorage.getItem("womanData")) {
    womanData = JSON.parse(localStorage.getItem("womanData"));
    womanData = womanData.filter((e) => e.wishlist).length;
  }
  if (localStorage.getItem("electronicsData")) {
    electronicsData = JSON.parse(localStorage.getItem("electronicsData"));
    electronicsData = electronicsData.filter((e) => e.wishlist).length;
  }
  wishlistLength.value =
    productsData + phoneData + freshvData + womanData + electronicsData;
};
Emitter.on("getLocalStorage", () => {
  getLength();
  console.log(wishlistLength.value);
});
onMounted(() => {
  getLength();
});
</script>
